import React, { useState } from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { Collapse } from 'react-collapse'
import Font from '@cred/react-font'
import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import ProductTile from '../product-tile'
import styles from './styles.scss'

const ShortDashboard = ({ products, trackSnowplowEvent, ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const bestProducts = products.length > 3 ? products.slice(0, 3) : products,
    hiddenProducts = products.length > 3 ? products.slice(3, products.length) : []
  const collapseToggle = () => {
    setIsOpen(!isOpen)
    trackSnowplowEvent(collapsibleClick, {
      text: `View ${hiddenProducts.length} more lender${hiddenProducts.length > 1 ? 's' : ''}`,
      action: isOpen ? 'collapse' : 'expand',
    })
  }
  return (
    <>
      {bestProducts.map(product => (
        <ProductTile product={product} key={product.uuid} {...props} />
      ))}
      {products.length > 3 && (
      <>
        {!isOpen && (
        <div onClick={collapseToggle} className={styles.collapseHeader}>
          <Font type="bodySmall" color="lighter" weight="semiBold">
          View {hiddenProducts.length} more lender{hiddenProducts.length > 1 ? 's' : ''} <i className="cred-icon icon-chevron-down" />
          </Font>
        </div>
        )}
        <Collapse isOpened={isOpen}>
          {hiddenProducts.map(product => (
            <ProductTile product={product} key={product.uuid} {...props} />

          ))}
        </Collapse>
        {isOpen && (
        <div onClick={collapseToggle} className={`${styles.collapseHeader} ${styles.borderTop}`}>
          <Font type="bodySmall" color="lighter" weight="semiBold">
          Hide additional lender{hiddenProducts.length > 1 ? 's' : ''} <i className="cred-icon icon-chevron-up" />
          </Font>
        </div>
        )}
      </>
      )}
    </>
  )
}

ShortDashboard.propTypes = {
  products: PropTypes.array.isRequired,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

const App = compose(withSnowplowContexts)(ShortDashboard)

export default App
